// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PauseCircleFilledSvg from "@fishx/icons-svg/es/asn/PauseCircleFilled";
import FishxIcon from '../components/FishxIcon';

var PauseCircleFilled = function PauseCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleFilledSvg
  }));
};

PauseCircleFilled.displayName = 'PauseCircleFilled';
export default React.forwardRef(PauseCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PauseCircleFilled.js
// module id = 3758
// module chunks = 0